import React from 'react'

export default function ContactStrip({ onContactClick }) {
  return (
    <div className="contact-strip">
      <div className="contact-strip-left">
        <h3>Gostou de algum modelo?</h3>
        <p>Todos os modelos podem ser personalizados para a sua marca.</p>
      </div>
      <div className="contact-strip-right">
        <a
          href="https://www.instagram.com/f.fsolutions/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
          </svg>
          Instagram
        </a>
        <button className="btn btn-primary" onClick={onContactClick}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          Entrar em contato
        </button>
      </div>
    </div>
  )
}
